import {
  formattedPropertyModel,
  RenderingServices,
  utils,
} from '@wallaby-ui/core';
import {isNil, isString} from 'lodash';

import {DEFAULT_RIGHT_COLOR} from 'src/js/common/components/formatters/GradientProgressFormatter';
import {
  CellRendererParams,
  CELL_RENDERER_PARAMS,
  CELL_RENDERER_PARAMS_AG,
} from 'src/js/model/cell_renderer_params';

export default function baseProgressFormatterParams(
  params,
  services: RenderingServices = {}
) {
  const {value, colDef} = params;
  const {intl} = services;

  const formatterParams = new CellRendererParams(
    colDef[CELL_RENDERER_PARAMS_AG] || colDef[CELL_RENDERER_PARAMS] || {}
  );

  const backgroundColor = formatterParams.getColor()
    ? formatterParams.getColor()
    : utils.ColorUtils.rgbToHex(DEFAULT_RIGHT_COLOR);

  const fontStyle = formatterParams.getFontFamily()
    ? formatterParams.getFontFamily()
    : 'SourceSansPro-Bold';

  // JSON format of the formatter value
  let label;
  let progressValue;
  if (formatterParams.getParse()) {
    let parsed = {};
    if (!isNil(value)) {
      if (value.value) {
        parsed = JSON.parse(value.value);
      } else if (isString(value)) {
        parsed = JSON.parse(value);
      }
    }
    if (parsed.tooltip && intl) {
      label = utils.TranslateUtils.translate(parsed.tooltip, intl);
    }
    progressValue = parsed.value;
  } else {
    progressValue = value;
  }

  // format percents
  const propDefinition = new formattedPropertyModel.FormattedProperty({
    type: formattedPropertyModel.FORMATTED_PROPERTY_TYPE_PERCENT,
  });
  const formattedValue = formattedPropertyModel.FormattedProperty.formatValue(
    propDefinition,
    progressValue,
    intl
  );

  return {
    ...params,
    progressValue,
    formattedValue,
    label,
    backgroundColor,
    fontStyle,
  };
}
